import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 检查 URL 中的 token 参数（飞书 OAuth 回调）
const urlParams = new URLSearchParams(window.location.search)
const token = urlParams.get('token')
if (token) {
  localStorage.setItem('emochi_token', token)
  // 清除 URL 中的 token
  window.history.replaceState({}, '', '/')
}

// 恢复登录状态
const savedToken = localStorage.getItem('emochi_token')
if (savedToken) {
  store.dispatch('restoreSession', savedToken)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
